import { inject, type InjectionKey } from "vue";
import type { AuthProvider } from "@token/shared";

export const authKey: InjectionKey<AuthProvider> = Symbol("auth");

export function useAuth(): AuthProvider {
  const auth = inject(authKey);
  if (!auth) {
    throw new Error("Auth provider not installed. Did you forget app.provide(authKey, ...) in main.ts?");
  }
  return auth;
}
